import { useMutation } from '@tanstack/react-query'
import { supabase } from '../../api'

const add = async (userId: string, tradingPlatformId: number, categoryId: number) => {
  const { data: updateData, error: updateError } = await supabase
    .from('trading_platforms_users')
    .update({
      trading_platform_id: tradingPlatformId,
    })
    .eq('user_id', userId)
    .eq('category_id', categoryId)

  if (updateError) {
    throw new Error(updateError.message)
  }

  return updateData
}

export default function useUpdateUserTrading(userId: string, categoryId: number) {
  return useMutation((tradingPlatformId: number) => add(userId, tradingPlatformId, categoryId), {
    onSuccess: async (data) => data,
  })
}
